import { createContext } from 'react';
import IContext from '../interfaces/IContext';
const AppContext = createContext<IContext | undefined>(undefined);
export default AppContext;
